import { Alert, Breadcrumb, BreadcrumbItem, Button, Col, DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table, UncontrolledDropdown } from "reactstrap";
import styles from "../../assets/css/EmpowerMeScheduler.module.css"
import { useEmpowerMeBundlesActiveAndForUserOnly, useEmpowerMeBundlesCategoriesActive } from "../../hooks/useEmpowerMe";
import Category from "../../interfaces/models/Category";
import { useEffect, useRef, useState } from "react";
import { useCategoriesEmpowerMe } from "../../hooks/useCategories";
import { EmpowerMeBundle } from "../../interfaces/models/EmpowerMeBundle";
import { EmpowerMeBundleCategory } from "../../interfaces/models/EmpowerMeBundleCategory";
import { getImageSmallUrl } from "../../helper/getImageUrl";
import Loading from "../../components/Loading";
import { useMutation, useQuery } from "@apollo/client";
import { getEmpowerMeTasksActive } from "../../graphql/empower-me/EmpowerMeQueries";
import { EmpowerScheduledTask, EmpowerTask } from "../../interfaces/models/EmpowerTask";
import { getEmpowerMeTaskScheduleOnly } from "../../graphql/empower-me/EmpowerMeQueries"; 
import DefaultImage from "../../assets/img/brand/deskcoachappicon.svg"
import { Form, Formik, FormikProps } from "formik";
import { Frequency, RRule } from "rrule";
import moment from "moment";
import { DateFormat, UserActivityTypeWithGroup } from "../../helper/constants";
import DateTime from "react-datetime";
import { RRuleEndAfterCountFieldName, RRuleEndConditionFieldName, RRuleEndNever, RRuleEndOnDateFieldName } from "./Scheduling/EmpowerMeFormFieldConstants";
import { RecurrenceSelection } from "./Scheduling/EmpowerMeRecurrenceSelection";
import FormError from "../../components/Shared/Forms/FormError";
import { parseRRuleToObject } from "../../helper/rruleUtilities";
import toast from "react-hot-toast";
import { AddActivityHookExecute, ModelEnums } from "../../helper/addUserActivity";
import { CreateEmpowerMeTask, CreateEmpowerMeTaskBundle } from "../../graphql/empower-me/mutations/CreateEmpowerMeTask";
import { useHistory } from "react-router-dom";
import { DASHBOARD_ROOT, EMPOWER_ME } from "../../components/Routes/routingConstants";
import { addEmpowerMeBundlePersonal, removeEmpowerMeBundlePersonal, updateEmpowerMeBundlePersonal } from "../../graphql/empower-me/mutations/addEmpowerMeBundle";
import PromptDialogs from "../../components/PromptDialog";
import CarouselRenderer from "../../components/Shared/CarouselRenderer";
import { SeparatePortions } from "../../helper/Utilities";

interface CategoryRenderInterface {
  id : string;
  image_or_color? : string;
  description : string;
  category? : Category;
  bundle? : EmpowerMeBundleCategory;
  isPersonal? : boolean
  onClick : (category : Category, bundle : EmpowerMeBundleCategory, isPersonal? : boolean) => void; 
}

interface EmpowerMeRenderInterface {
    item : EmpowerTask,
    onClick : (item : EmpowerTask) => void;
}

interface EmpowerMeBundleRenderInterface {
    item : EmpowerMeBundle,
    onClick : (item : EmpowerMeBundle) => void;
}


interface EmpowerMeBundleForm {
    _id : string;
    name : string;
    description : string;
}

interface EmpowerScheduleForm {
  taskId?: string;
  bundleId?: string;
  date?: string;
  time?: string;
  repeatInterval?: number;
  repeatFrequency?: Frequency; // RRule.Frequency: DAILY, WEEKLY, MONTHLY
  rRuleEndRadio?: string;
  endRRuleOnDate?: string;
  endRRuleAfterCount?: number;
  bundleTimes? : string[]
}

interface MyBundleModalParams {
    action : string;
    buttonName : string;
    label : string;
}

const SelectionTypes = {
  SINGLE: 1,
  BUNDLE: 2,
}

const ConstantLinkNames = {
    EM_HOME : "Home",
    ADD_TASK : "Schedule Single/Bundle Task",
}

const InitialMyBundle  = () => {

    return {_id : "my-bundles", name : "My Personal Bundles", description : "My Personal Bundles",status : true, image_id : "", level : 1}
}
 
const InitialBreadcrumbsLink = [ConstantLinkNames.EM_HOME, ConstantLinkNames.ADD_TASK];

export default function EmpowerMeSchedulerPage() {

    const queryParams = new URLSearchParams(window.location.search);
    const showPersonal = queryParams.get("showPersonal");
    
    const dateNow = useRef<Date>(new Date());
    
    const history = useHistory();

    const [selectionType,setSelectionType] = useState<number>(SelectionTypes.SINGLE);

    const [categories, setCategories] = useState<Category[]>([]);
    const [subCategories, setSubCategories] = useState<Category[]>([]);

    const [selectedCategory, setSelectedCategory] = useState<Category>(null);
    const [selectedSubCategory, setSelectedSubCategory] = useState<Category>(null);

    const [selectedBundle, setSelectedBundle] = useState<EmpowerMeBundleCategory>(null);
    const [selectedSubBundle, setSelectedSubBundle] = useState<EmpowerMeBundleCategory>(null);

    const [selectedSingleEmTask, setSelectedSingleEmTask] = useState<EmpowerTask>(null);
    const [selectedEmpowerMeBundle, setSelectedEmpowerMeBundle] = useState<EmpowerMeBundle>(null);

    const [empowerMeTasksSingles, setEmpowerMeTasksSingles] = useState<EmpowerTask[]>([]);

    const [breadcrumbs, setBreadcrumbs] = useState<string[]>(InitialBreadcrumbsLink);
    const [activeBreadcrumbs, setActiveBreadcrumbs] = useState<number>(1);
    
    const [empowerMeBundles, setEmpowerMeBundles] = useState<EmpowerMeBundle[]>([]);
    const [empowerMeBundlesPersonal, setEmpowerMeBundlesPersonal] = useState<EmpowerMeBundle[]>([]);
    const [empowerMeBundlesCategory, setEmpowerMeBundlesCategory] = useState<EmpowerMeBundleCategory[]>([]);
    const [empowerMeBundlesSubCategory, setEmpowerMeBundlesSubCategory] = useState<EmpowerMeBundleCategory[]>([]);
    const [empowerTasks, setEmpowerTasks] = useState<EmpowerScheduledTask[]>([]);
    
    const { data : categData, loading : categLoading} = useCategoriesEmpowerMe();
    const { loading: loadingBundles, data: dataBundles } = useEmpowerMeBundlesActiveAndForUserOnly();
    const { data: dataBundlesCategory } = useEmpowerMeBundlesCategoriesActive();

    const { executeAddActivity } = AddActivityHookExecute();
    const [createEmpowerMeTaskBundle] = useMutation(CreateEmpowerMeTaskBundle);
    const [createEmpowerMeTask] = useMutation(CreateEmpowerMeTask);
    
    const formikRef = useRef<FormikProps<EmpowerScheduleForm>>(null);
    const [initialSingleNudgeValue, setInitialSingleNudgeValue] = useState<EmpowerScheduleForm>(null); 

    const formikRefBundle = useRef<FormikProps<EmpowerScheduleForm>>(null);
    const [initialBundleNudgeValue, setInitialBundleNudgeValue] = useState<EmpowerScheduleForm>(null); 

    const [isPersonalBundleSelected, setIsPersonalBundleSelected] = useState<boolean>(false);

    const [openSingleSchedulerModal, setOpenSingleSchedulerModal] = useState<boolean>(false);
    const [openBundleSchedulerModal, setOpenBundleSchedulerModal] = useState<boolean>(false);
    const [openBundleCreatorModal, setOpenBundleCreatorModal] = useState<boolean>(false);

    const [repeatSingle, setRepeatSingle] = useState<boolean>(false);
    const [repeatBundle, setRepeatBundle] = useState<boolean>(false);

    const [isOnProcess, setIsOnProcess] = useState<boolean>(false);

    const [selectedMyBundleMainCategory, setSelectedMyBundleMainCategory ] = useState<Category>(null);
    const [selectedMyBundleSubCategory, setSelectedMyBundleSubCategory ] = useState<Category>(null);
    const [selectedMyBundleSelectedEmpowerTasks, setSelectedMyBundleSelectedEmpowerTasks ] = useState<EmpowerTask[]>([]);

    const [breadcrumbsMyBundle, setBreadcrumbsMyBundle] = useState<string[]>([]);
    const [activeMyBundleBreadcrumbs, setActiveMyBundleBreadcrumbs] = useState<number>(0);
    const [myBundleStep, setMyBundleStep] = useState<number>(1);

    const [activeSingleIndex, setActiveSingleIndex] = useState<number>(0);
    const [activeBundleIndex, setActiveBundleIndex] = useState<number>(0);
    const [activeMyBundleIndex, setActiveMyBundleIndex] = useState<number>(0);

    const [selectedMyBundle, setSelectedMyBundle] = useState<EmpowerMeBundleForm>(null);
    const [myBundleModalParams, setMyBundleModalParams] = useState<MyBundleModalParams>({
        action : "",
        buttonName : "",
        label : ""
    });

    const [isDeleteMyBundleModalOpen, setIsDeleteMyBundleModalOpen] = useState<boolean>(false);
 
    let { loading : empowerMeSingleLoading } = useQuery(getEmpowerMeTasksActive, {
        onCompleted(data) {
            if(data) {
            setEmpowerMeTasksSingles(data?.empower_me_tasks_active);
            }
        },
        onError(error) {
            console.error("Error occurred: ", error);
        },
    });

    const { loading : loadingEmTask } = useQuery(getEmpowerMeTaskScheduleOnly, {
        onCompleted(data) {
            const results =
                data?.me?.empower_task_schedule?.scheduled_tasks?.map((task) => {
                    return task;
                }) ?? [];
            setEmpowerTasks(results);
        },
        onError(error) {
            console.error(error);
        },
        fetchPolicy: "network-only",
        notifyOnNetworkStatusChange: true, // Useful for invoking `onCompleted` during `refetch` calls
    });

    const [addEmpowerMeBundlePersonalHook] = useMutation(addEmpowerMeBundlePersonal,{
        onCompleted : () =>{
            toast.success("Bundle was successfully Added");
        },
        onError : () =>{
            toast.error("Something went wrong whilst adding Bundle details. Please try again or if issue persists, please contact us");
        }
    });

    const [updateEmpowerMeBundlePersonalHook] = useMutation(updateEmpowerMeBundlePersonal,{
        onCompleted : () =>{
            toast.success("Bundle was successfully Edited");
        },
        onError : () =>{
            toast.error("Something went wrong whilst Editing Bundle details. Please try again or if issue persists, please contact us");
        }
    });

    const [removeEmpowerMeBundlePersonalHook] = useMutation(removeEmpowerMeBundlePersonal,{
        onCompleted : () =>{
            toast.success("Bundle was successfully Deleted");
        },
        onError : (error) =>{
            toast.error(error.graphQLErrors[0].message);
        }
    });

    useEffect(() => {
        if(showPersonal === "true") {
            setSelectionType(SelectionTypes.BUNDLE);
            MainCategorySelector(null, InitialMyBundle(), true);
        }
    },[showPersonal])

    useEffect(() => {
        if(dataBundles && dataBundlesCategory) {
            const bundles : EmpowerMeBundle[] = dataBundles.empower_me_bundles_for_user;

            setEmpowerMeBundles(bundles);
            setEmpowerMeBundlesPersonal(bundles.filter(u => u.bundle_category_id === null));

            const activeBundleCategoriesRaw : EmpowerMeBundleCategory[] = dataBundlesCategory.empower_me_bundle_categories_actives; 
            let main : EmpowerMeBundleCategory[] = [
                InitialMyBundle()
            ];
            let sub : EmpowerMeBundleCategory[] = [];

            for(let x = 0; x < activeBundleCategoriesRaw.length; x++) {
                const getActiveBundleCategoriesRaw = activeBundleCategoriesRaw[x];

                if(getActiveBundleCategoriesRaw.level === 1) {
                    main.push(getActiveBundleCategoriesRaw);
                }
                else {
                    sub.push(getActiveBundleCategoriesRaw);
                }
            }
            setEmpowerMeBundlesCategory(main);
            setEmpowerMeBundlesSubCategory(sub);
        }
    },[dataBundles, dataBundlesCategory]);

    useEffect(() => {
        if(categData) {
            let categRaw : Category[] = categData.categories_empower_me; 
            let mainCategs = [];
            let subCategs = [];
            for(let x = 0; x < categRaw.length; x++) {
                let categ = categRaw[x];

                if(categ.level === 2) {
                    mainCategs.push(categ);
                }
                else if (categ.level === 3){
                    subCategs.push(categ);
                }
            }
            setCategories(mainCategs);
            setSubCategories(subCategs);
        }
    }, [categData]);

    const Reloader = (query : string = "") => {
        setTimeout(() => {
            window.location.href = `${DASHBOARD_ROOT}/${EMPOWER_ME}/schedule?${query}`;
        },1200);
    }

    const HandleSync = () => {
        setTimeout(() => {
            window.location.href = `${DASHBOARD_ROOT}/${EMPOWER_ME}/schedule?syncEmpowerMe=true`;
        }, 1200)
    }

    const HandleChangeSelectionType = (type : number) => {

        if(selectionType === type) return;

        setSelectedBundle(null);
        setSelectedSubBundle(null);

        setSelectedCategory(null);
        setSelectedSubCategory(null);

        setActiveBreadcrumbs(1);
        setBreadcrumbs(InitialBreadcrumbsLink);

        setSelectionType(type);
        setIsPersonalBundleSelected(false);
    }

    const MainCategorySelector = (category : Category, bundle : EmpowerMeBundleCategory, isPersonal : boolean = false) => {
        if(category) {
            setSelectedCategory(category);
            setSelectedBundle(null);
        }
        else {
            setSelectedCategory(null);
            setSelectedBundle(bundle);
            
        }

        setSelectedSubCategory(null);
        setSelectedSubBundle(null);

        if(bundle !== null && isPersonal) {
            setIsPersonalBundleSelected(true);
            setBreadcrumbs([...InitialBreadcrumbsLink, "My Personal Bundles"]);
            setActiveBreadcrumbs(2);
        }
        else {
            setIsPersonalBundleSelected(false);
            setBreadcrumbs(InitialBreadcrumbsLink);
        }
    }
    const SubCategorySelector = (category : Category, bundle : EmpowerMeBundleCategory) => {
        if(category) {
            setSelectedSubCategory(category);
            setSelectedSubBundle(null);
            setBreadcrumbs([...InitialBreadcrumbsLink, category.description]);
        }
        else {
            setSelectedSubCategory(null);
            setSelectedSubBundle(bundle);

            setBreadcrumbs([...InitialBreadcrumbsLink, bundle.name]);
        }

        setActiveBreadcrumbs(2);
    }
    const MainCategoryRenderer = ({id , image_or_color , description, category, bundle, isPersonal, onClick } : CategoryRenderInterface) => {

        return (
          <div 
              className="text-center cursor-pointer "
              onClick={() => { onClick(category, bundle, isPersonal);}}
            >
                <div className="d-flex justify-content-center">
                    <div 
                        className="shadow-dark-em em-category"

                        style={
                                {
                                    borderRadius : "50%", 
                                    height: "130px", 
                                    width : "130px",
                                    backgroundColor : 
                                        (
                                            (selectedBundle != null && id === selectedBundle._id) ||
                                            (selectedCategory != null && id === selectedCategory._id) || 
                                            (selectedMyBundleMainCategory != null && id === selectedMyBundleMainCategory._id) || 
                                            (isPersonal && isPersonalBundleSelected)?
                                            "#ededed"
                                        :
                                            "white"
                                        )
                                }
                            } 
                        >
                        {
                            isPersonal === true ?
                            <img
                                className="mt-4"
                                src={getImageSmallUrl("17e4d074-b972-4918-f803-9824ed144d00")} //TODO: Make this Dynamic
                                alt={description}
                                style={{ 
                                    height: "80px",
                                    objectFit: "cover"
                                }}
                            />
                            :
                            <img
                                className="mt-4"
                                src={image_or_color ? getImageSmallUrl(image_or_color ) : DefaultImage}
                                alt={description}
                                style={{ 
                                    height: "80px",
                                    objectFit: "cover"
                                }}
                            />
                        }
                        
                    </div>
                </div>
                <div >{description}</div>
            </div>
        )
    }
    const MainCategoryRendererFormatterSingle = (category : Category) => {
        return (
            <MainCategoryRenderer 
                    id={category._id}
                    image_or_color={category.image}
                    description={category.description}
                    category={category}
                    onClick={MainCategorySelector}
                />
        )
    }
    const MainCategoryRendererFormatterMyBundle = (category : Category) => {
        return (
            <MainCategoryRenderer 
                    id={category._id}
                    image_or_color={category.image}
                    description={category.description}
                    category={category}
                    onClick={MyBundleMainCategorySelector}
                />
        )
    }

    const MainCategoryRendererFormatterBundle = (bundle : EmpowerMeBundleCategory) => {
        return (
            <>
                {
                    bundle._id === "my-bundles" ?
                    <MainCategoryRenderer
                            id="my-bundles"
                            description="My Personal Bundles"
                            isPersonal={true}
                            onClick={MainCategorySelector}
                        />
                    :
                    <MainCategoryRenderer 
                        id={bundle._id}
                        description={bundle.description}
                        bundle={bundle}
                        onClick={MainCategorySelector}
                        image_or_color={bundle.image_id}
                    />
                }
            </>
        )
    }

    const SubCategoryRenderer = ({id, description, category, bundle, onClick} : CategoryRenderInterface) => {
        return (
            <Col md={4} className="mt-3 " >
            <div 
                className="text-primary py-5 text-center shadow-dark-em em-category"
                style={{
                    borderRadius : "20px", 
                    backgroundColor : 
                        (
                            (selectedSubBundle != null && id === selectedSubBundle._id) ||
                            (selectedMyBundleSubCategory != null && id === selectedMyBundleSubCategory._id) ||
                            (selectedSubCategory != null && id === selectedSubCategory._id) ?
                            "#ededed"
                        :
                            "white"
                        )
                }}
                role="button"
                onClick={() => { onClick(category, bundle) }}
            >
                <span className="font-weight-bold my-2">{description} </span>
                
            </div>
            </Col>
        )
    }

    const EmpowerMeTaskItemsRenderer = ({ item, onClick } : EmpowerMeRenderInterface) => {
        const image = item?.image_id || item?.task_category?.image;
        return (
            <div className="d-flex align-items-center em-category shadow-dark-em p-2 mt-3" role="button" onClick={() => onClick(item) }
                style={{
                        borderRadius :"20px",
                        backgroundColor : 
                            (selectedSingleEmTask != null && item._id === selectedSingleEmTask._id) ||
                            (selectedMyBundleSelectedEmpowerTasks.findIndex( u => u._id === item._id) > -1)
                            ?
                                "#ededed"
                            :
                                "white"
                    }}
                >
                <div>
                    <img
                        alt="thumbnail"
                        style={{ width: "6rem", height : "80px", minHeight : "80px", objectFit : "cover"  }}
                        src={image ? getImageSmallUrl(item?.image_id || item?.task_category?.image) : DefaultImage}
                    />
                </div>
                <div>
                    <h5 className="pl-2 mb-0">{item.name}</h5>
                    <small className="text-muted pl-2" title={item.description} >{item.description?.length > 50 ? item.description.slice(0,50) + "..." : item.description}</small>
                </div>
            </div>
        )
    }

    const EmpowerMeBundleRenderer = ({ item , onClick} : EmpowerMeBundleRenderInterface) => {
        return (
            <div className="d-flex align-items-center em-category shadow-dark-em p-2 mt-3" role="button" onClick={() => onClick(item) }
                style={{
                        borderRadius : "20px", 
                        backgroundColor : 
                            selectedEmpowerMeBundle != null && item._id === selectedEmpowerMeBundle._id ?
                                "#ededed"
                            :
                                "white"
                    }}
                >
                <div>
                    <img
                        alt="thumbnail"
                        style={{ width: "6rem", height : "80px", minHeight : "80px", objectFit : "cover"  }}
                        src={item.tasks[0].empower_me_task_details.image_id  ? getImageSmallUrl(item.tasks[0].empower_me_task_details.image_id) : DefaultImage}
                    />
                </div>
                <div>
                    <h5 className="pl-2 mb-0">{item.name}</h5>
                    <small className="text-muted pl-2" title={item.description} >{item.description?.length > 50 ? item.description.slice(0,50) + "..." : item.description}</small>
                </div>
                {
                    item.bundle_category_id === null &&
                    <>
                        <UncontrolledDropdown
                            direction="left"
                            size="sm"
                            className="position-absolute top-3 right-0"
                            style={{transform: "translate(20%, -30%)"}}
                            onClick={(e) => { e.stopPropagation(); }}
                        >
                            <DropdownToggle
                                caret
                                color="primary"
                            >
                                Actions
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem onClick={() => HandleOpenEditMyBundleCreator(item)} >Edit</DropdownItem>
                                <DropdownItem onClick={() => HandleOpenDeleteBundle(item)}>Delete</DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </>
                }
            </div>
        )
    }

    const HandleBreadcrumbsClick = (index : number) => {

        if(index === 0) {
            history.push(`${DASHBOARD_ROOT}/${EMPOWER_ME}`)

            return;
        }

        if(selectedSubCategory && index === 1) {
            setActiveBreadcrumbs(1);
            setSelectedSubCategory(null);
            setBreadcrumbs(InitialBreadcrumbsLink);
        }
        else if(selectedSubBundle && index === 1) {
            setActiveBreadcrumbs(1);
            setSelectedSubBundle(null);
            setBreadcrumbs(InitialBreadcrumbsLink);
        }
        else if(isPersonalBundleSelected && index === 1) {
            setActiveBreadcrumbs(1);
            setIsPersonalBundleSelected(false);
            setBreadcrumbs(InitialBreadcrumbsLink);
        }
    }

    const HandleSelectSingleEmTask = (task : EmpowerTask) => {
        setSelectedSingleEmTask(task);

        const nextQuarter = moment()
            .add(15 - (moment().minute() % 15), 'minutes')
            .startOf('minute')
            .format("HH:mm");
        const initialValues: EmpowerScheduleForm = {
            taskId: task._id,
            date: moment().format("yyyy-MM-DD"),
            time: nextQuarter,
            repeatInterval: 1,
            repeatFrequency: Frequency.DAILY,
            rRuleEndRadio: RRuleEndNever,
            endRRuleOnDate: undefined,
            endRRuleAfterCount: 0,
        };

        setInitialSingleNudgeValue(initialValues);

        ToggleSingleModal();
    }

    const HandleSelectBundleTask = (bundle : EmpowerMeBundle) => {
        setSelectedEmpowerMeBundle(bundle);

        const initialValues: EmpowerScheduleForm = {
            bundleId : bundle._id,
            date: moment().format("yyyy-MM-DD"),
            repeatInterval: 1,
            repeatFrequency: Frequency.DAILY,
            rRuleEndRadio: RRuleEndNever,
            endRRuleOnDate: undefined,
            endRRuleAfterCount: 0,
            bundleTimes : ["09:00", "10:00","11:00"]
        };

        setInitialBundleNudgeValue(initialValues);
        ToggleBundleModal();
    }

    const SingleSelector = () => {

        return (
            <>
                {
                    categLoading &&  loadingEmTask &&
                    <div className="text-center pt-5">
                        <Loading />
                    </div>
                }
                {
                    activeBreadcrumbs === 1 && 
                    <div className="mt-3">
                        <CarouselRenderer
                            data={SeparatePortions(categories,3)}
                            renderer={MainCategoryRendererFormatterSingle}
                            activeIndex={activeSingleIndex}
                            setActiveIndex={setActiveSingleIndex}
                            colSize={4}
                        />
                    </div>
                }
                
                
                {
                    activeBreadcrumbs === 1 && selectedCategory &&
                    <>
                        <div className="section-line-em" />
                        <div>
                            <span>Step 2: Pick a topic and see the list of nudges.</span>
                        </div>
                        <Row className="mt-3">
                            {
                                subCategories.filter(u => u.parent_id === selectedCategory._id).map((item, index) => (
                                    <SubCategoryRenderer 
                                        key={index}
                                        id={item._id}
                                        description={item.description}
                                        category={item}
                                        onClick={SubCategorySelector}
                                    />
                                ))
                            }

                        </Row>
                    </>
                }

                {
                    activeBreadcrumbs === 2 && selectedSubCategory &&
                    <>
                        <Row>
                            {
                                empowerMeSingleLoading &&
                                <Loading />
                            }
                            {
                                empowerMeTasksSingles.filter(u => u.task_category._id === selectedSubCategory?._id).map((item, index) => (
                                    <Col md={6} key={index}>
                                        <EmpowerMeTaskItemsRenderer
                                            item={item}
                                            onClick={HandleSelectSingleEmTask}
                                        />
                                    </Col>
                                ))
                            }
                        </Row>
                    </>
                }
            </>
        )
    }

    const BundleSelector = () => {

        return (
            <>
                {
                    categLoading &&  loadingEmTask &&
                    <div className="text-center pt-5">
                        <Loading />
                    </div>
                }
                {
                    activeBreadcrumbs === 1 && 
                    <div className="mt-3">
                        <CarouselRenderer
                            data={SeparatePortions(empowerMeBundlesCategory,4)}
                            renderer={MainCategoryRendererFormatterBundle}
                            activeIndex={activeBundleIndex}
                            setActiveIndex={setActiveBundleIndex}
                            colSize={3}
                        />
                    </div>
                }
                
                {
                    activeBreadcrumbs === 1 && selectedBundle && 
                    <>
                        <div className="section-line-em" />
                        <div>
                            <span>Step 2: Pick a topic and see the list of nudges.</span>
                        </div>
                        <Row className="mt-3">
                            {
                                empowerMeBundlesSubCategory.filter(u => u.parent_id === selectedBundle._id).map((item, index) => (
                                    <SubCategoryRenderer 
                                        key={index}
                                        id={item._id}
                                        description={item.description}
                                        bundle={item}
                                        onClick={SubCategorySelector}
                                    />
                                ))
                            }

                        </Row>
                    </>
                }

                {
                    activeBreadcrumbs === 2 && selectedSubBundle &&
                    <>
                        <Row>
                            {
                                loadingBundles &&
                                <Loading />
                            }
                            {
                                empowerMeBundles.filter(u => u.bundle_category_id === selectedSubBundle._id).map((item, index) => (
                                    <Col md={6} key={index}>
                                        <EmpowerMeBundleRenderer 
                                            item={item}
                                            onClick={HandleSelectBundleTask}
                                        />
                                        
                                    </Col>
                                ))
                            }
                        </Row>
                    </>
                }

                {
                    activeBreadcrumbs === 2 && isPersonalBundleSelected &&
                    <>
                        <div className="d-flex justify-content-end mb-2  mt-3">
                            <Button color="primary" onClick={() => HandleOpenMyBundleCreator()}>Create My Bundle</Button>
                        </div>
                        {
                            empowerMeBundlesPersonal.length === 0 && !loadingBundles &&
                            <Alert color="info" className="mt-4">No Personal Bundle Found</Alert>
                        }
                        <Row>
                            {
                                empowerMeBundlesPersonal.map((item, index) => (
                                    <Col md={6} key={index} >
                                        <EmpowerMeBundleRenderer 
                                            item={item}
                                            onClick={HandleSelectBundleTask}
                                        />
                                    </Col>
                                ))
                            }

                        </Row>
                    </>
                }
            </>
        )
    }

    const ToggleSingleModal = () => {

        const updatedState = !openSingleSchedulerModal;

        setOpenSingleSchedulerModal(updatedState);

        if(updatedState === false) {
            setSelectedSingleEmTask(null);
        }
    }

    const ToggleBundleModal = () => {

        const updatedState = !openBundleSchedulerModal;

        setOpenBundleSchedulerModal(updatedState);

        if(updatedState === false) {
            setSelectedEmpowerMeBundle(null);
        }
    }

    const HandleSingleSubmit = async (formData : EmpowerScheduleForm) => {
        if(isOnProcess) return;

        let rrule = null
        if(repeatSingle) {
            rrule = ValidateRrule(formData);
            if(rrule === null) return;
        }

        if(ValidateDate(formData.date, formData.time) !== null) return;

        // All valid go 
        setIsOnProcess(true);
        const start_date_iso = new Date(formData.date + " " + formData.time).toISOString();
        const result  = await createEmpowerMeTask({
          variables: {
            task_id: selectedSingleEmTask._id,
            start_date: start_date_iso,
            recurrence_rule: rrule,
          },
        })
        .then((res) => res.errors ? false : true)
        .catch( (error) => false);


        if(result === false) {
            toast.error("Sorry something went wrong while scheduling your nudge");
            setIsOnProcess(false);
            return;
        }

        executeAddActivity({
            type : UserActivityTypeWithGroup.EM_CREATE.id, 
            type_group : UserActivityTypeWithGroup.EM_CREATE.group,
            on_model : ModelEnums.EM,
            related_id : selectedSingleEmTask._id,
        });


        toast.success("EM Nudge added successfully. Please wait while we schedule your task.");
        HandleSync();
        
    }

    const HandleBundleSubmit = async (formData : EmpowerScheduleForm) => {
        if(isOnProcess) return;

        let rrule = null
        if(repeatBundle) {
            rrule = ValidateRrule(formData);
            if(rrule === null) return;
        }

        let tasks_reformated = [];
        for(let x = 0; x < formData.bundleTimes.length; x++) {
            if(ValidateDate(formData.date, formData.bundleTimes[x], x) !== null) return;
            const get_start_date = new Date(`${formData.date}T${formData.bundleTimes[x]}`).toISOString();
            tasks_reformated.push({
                task_id: selectedEmpowerMeBundle.tasks[x].empower_me_task_details._id,
                start_date: get_start_date,
                bundle_id : selectedEmpowerMeBundle._id,
                recurrence_rule: rrule,
            });
        }
        
        // All valid go 
        setIsOnProcess(true);

        const result =  await createEmpowerMeTaskBundle({
          variables: {
            tasks: tasks_reformated,
            bundle_id: selectedEmpowerMeBundle._id,
          },
        })
        .then((res) => {
            if(res.errors) {
                return {
                    errors : null
                }  
            }
            return {
                errors : null
            }
        })
        .catch( (error) => {
            if(error.message) {
                return {
                    errors : [
                        {
                            message : error.message
                        }
                    ]
                }
            }
            else if (error.graphQLErrors) {
                return {
                    errors : error.graphQLErrors
                };
            }

            return {
                errors : [
                    {
                        message : "Sorry something went wrong"
                    }
                ]
            };
            
        });

        if(result.errors) {
            toast.error(result.errors[0].message);
            setIsOnProcess(false);
            return;
        }

        executeAddActivity({
            type : UserActivityTypeWithGroup.EM_CREATE.id, 
            type_group : UserActivityTypeWithGroup.EM_CREATE.group,
            on_model : ModelEnums.EM_BUNDLE,
            related_id : selectedEmpowerMeBundle._id,
        });


        HandleSync();
        toast.success("EM bundle added successfully. Please wait while we schedule your task.");

    }

    const HandleSingleChangeRepeat = (repeat : boolean) => {
        setRepeatSingle(repeat);
    }

    const HandleBundleChangeRepeat = (repeat : boolean) => {
        setRepeatBundle(repeat);
    }

    const ValidateRrule = (values : EmpowerScheduleForm) => {
        let rrule = null;
        try {
            const rRuleEndCondition = values.rRuleEndRadio;
                rrule = new RRule({
                    freq: values.repeatFrequency,
                    interval: values.repeatInterval,
                    dtstart: undefined,
                    until:
                    rRuleEndCondition === RRuleEndOnDateFieldName
                        ? new Date(Date.parse(values.endRRuleOnDate))
                        : undefined,
                    count:
                    rRuleEndCondition === RRuleEndAfterCountFieldName
                        ? values.endRRuleAfterCount
                        : undefined,
            }).toString();

            return rrule;
        } catch (error) {
            console.log(
                "Error ocurred whilst constructing recurrence rule string: ",
                error
            );
        }
    } 

    const ValidateDate = (date: string, time : string, index? : number | null) => {
    
        if(!date && !time){
          return "Please select a date and time";
        }
    
        if(index !== null && index !== undefined) {
            const getCurrent = moment(date + " " + time, "YYYY-MM-DD HH:mm").toDate();
            if(getCurrent.getTime() <= dateNow.current.getTime() ) {
                return "Please choose a time in the future"
            }
            let duplicateCount = 0;
            const bundleTimeValues = formikRefBundle.current?.values.bundleTimes || [];
            for(let x = 0; x < bundleTimeValues.length; x++) {
                const bundleDateItem = moment(date + " " + bundleTimeValues[x], "YYYY-MM-DD HH:mm").toDate();
                if(getCurrent.getTime() === bundleDateItem.getTime()) {
                    duplicateCount++;
                }
            }
            if(duplicateCount > 1) {
                return "Time overlapped with other bundle tasks"
            }
        }
        else {
            const getCurrent = moment(date + " " + time, "YYYY-MM-DD HH:mm").toDate();
            if(getCurrent.getTime() <= dateNow.current.getTime() ) {
                return "Please choose a time in the future"
            }
        }
    
        const getDate = moment(date + " " + time, "YYYY-MM-DD HH:mm");
        const haveOverlappedMessage = "A task is already scheduled for this time";
        for (let x = 0; x < empowerTasks.length; x++) {
            const task = empowerTasks[x];

            if(task.deleted_at) continue;

            const targetDate = getDate.toDate();

            // Check non-repeating tasks
            const taskDate = moment(new Date(task.start_date)).toDate();

            if (targetDate.getTime() === taskDate.getTime()) {
                return haveOverlappedMessage;
            }
            if (task.recurrence_rule !== null) {
                const optionRules = parseRRuleToObject(task.recurrence_rule);
                const startDate = new Date(task.start_date);
                if(optionRules.origOptions.freq === RRule.DAILY && optionRules.options.interval === 1 && optionRules.origOptions.until) {
                    const until = optionRules.origOptions.until;

                    if(targetDate >= startDate && targetDate <= until && moment(startDate).format("HH:mm") === moment(targetDate).format("HH:mm")) {
                    return haveOverlappedMessage;
                    }
                }
                else if(optionRules.origOptions.freq === RRule.DAILY && optionRules.options.interval === 1 && optionRules.origOptions.until === undefined) {
                    //check for interval based on the frequency
                    if(moment(startDate).format("HH:mm") === moment(targetDate).format("HH:mm")) {
                    return haveOverlappedMessage;
                    }
                }
                else {
                    const rule = new RRule({
                        freq: optionRules.options.freq,
                        interval: optionRules.options.interval,
                        dtstart: startDate,
                        until : optionRules.options.until
                    });
                    let upcomming = null;
            
                    if(!optionRules.options.until) {
                        const now = new Date();
                        const oneMonthFromNow = new Date();
                        oneMonthFromNow.setFullYear(now.getMonth() + 1);
                        
                        upcomming = rule.between(now, oneMonthFromNow, true);
                    }
                    else {
                        upcomming = rule.between(startDate, optionRules.options.until, true);
                    }
            
                    if(upcomming.some(
                        (occurrence : Date) => occurrence.getTime() === targetDate.getTime()
                    )) {
                        return haveOverlappedMessage;
                    }
                }
            }
        }
    
        return null;
    }

    const HandleValidationDate = (date: string, time : string, index? : number | null) => {
        console.log(date, time, index)
        const result = ValidateDate(date, time, index);

        if(result !== null) return <FormError><small>{result}</small></FormError>;

        return <></>
        
    }

    const ToggleBundleCreatorModal = () => {
        setOpenBundleCreatorModal(!openBundleCreatorModal);
    }

    const HandleOpenMyBundleCreator = () => {

        setSelectedMyBundleMainCategory(null);
        setSelectedMyBundleSubCategory(null);
        setSelectedMyBundleSelectedEmpowerTasks([]);

        setBreadcrumbsMyBundle([]);
        setActiveMyBundleBreadcrumbs(0);

        setMyBundleStep(1);

        setMyBundleModalParams({
            action : "add",
            buttonName : "Create",
            label : "Create My Bundle"
        });

        setSelectedMyBundle({
            _id : "",
            name : "",
            description : "",
        });

        ToggleBundleCreatorModal();
    }

    const HandleOpenEditMyBundleCreator = (item : EmpowerMeBundle) => {

        setSelectedMyBundleMainCategory(null);
        setSelectedMyBundleSubCategory(null);

        setBreadcrumbsMyBundle([]);
        setActiveMyBundleBreadcrumbs(0);

        setMyBundleStep(1);

        setMyBundleModalParams({
            action : "edit",
            buttonName : "Edit",
            label : "Update my Bundle"
        });

        setSelectedMyBundle({
            _id : item._id,
            name : item.name,
            description : item.description,
        });

        setSelectedMyBundleSelectedEmpowerTasks([...item.tasks.map(u => u.empower_me_task_details)]);

        ToggleBundleCreatorModal();
    }

    const MyBundleMainCategorySelector = (category : Category, bundle : EmpowerMeBundleCategory, isPersonal : boolean = false) => {
        setSelectedMyBundleMainCategory(category);

        setBreadcrumbsMyBundle([category.description])
    }
    const MyBundleSubCategorySelector = (category : Category, bundle : EmpowerMeBundleCategory) => {
        setSelectedMyBundleSubCategory(category);

        setBreadcrumbsMyBundle([selectedMyBundleMainCategory.description, category.description]);
        setActiveMyBundleBreadcrumbs(3);
    }
    const HandleMyBundleBreadcrumbsClick = (index : number) => {
        if(activeMyBundleBreadcrumbs === index) return;

        if(index === 0 && selectedMyBundleSubCategory) {
            setBreadcrumbsMyBundle([selectedMyBundleMainCategory.description]);
            setSelectedMyBundleSubCategory(null);
        }
        else if(index === 1) {
            setSelectedMyBundleSubCategory(null);
        }

        setActiveMyBundleBreadcrumbs(index);
    }

    const HandleSelectMyBundleEmTask = (item : EmpowerTask) => {

        const myBundleTasks = [...selectedMyBundleSelectedEmpowerTasks];
        const getIndex = myBundleTasks.findIndex( u => u._id === item._id);
        if(myBundleTasks.length === 3) {
            toast.error("Only 3 Nudge Task are allowed Per Bundle");
            return;
        }
        if(getIndex === -1) {
            myBundleTasks.push(item);
        }

        setSelectedMyBundleSelectedEmpowerTasks(myBundleTasks);
    }

    const HandleCreateMyBundleSubmit = async () => {

        if(selectedMyBundle.description.length === 0 || selectedMyBundle.name.length === 0 
            || selectedMyBundleSelectedEmpowerTasks.length !== 3) {
            return;
        }

        setIsOnProcess(true);
        let isSuccess = false;

        if(myBundleModalParams.action === "add") {
            isSuccess = await addEmpowerMeBundlePersonalHook({
                variables : {
                    record : {
                        name : selectedMyBundle.name,
                        description : selectedMyBundle.description,
                        status : true,
                        tasks : selectedMyBundleSelectedEmpowerTasks.map((item) => {
                            return {
                                empower_me_task_id : item._id
                            }
                        }),
                    }
                }
            }).then((res) => res.errors ? false : true).catch(()=>false);
        }
        else {
            isSuccess = await updateEmpowerMeBundlePersonalHook({
                variables : {
                    _id : selectedMyBundle._id,
                    record : {
                        name : selectedMyBundle.name,
                        description : selectedMyBundle.description,
                        status : true,
                        tasks : selectedMyBundleSelectedEmpowerTasks.map((item) => {
                            return {
                                empower_me_task_id : item._id
                            }
                        }),
                    }
                }
            }).then((res) => res.errors ? false : true).catch(()=>false);
        }
        
        if(!isSuccess) {
            setIsOnProcess(false);
            return;
        }
        Reloader("showPersonal=true");
        // Reloader();
    }
    
    const HandleOpenDeleteBundle = (bundle : EmpowerMeBundle) => {
        setSelectedMyBundle({
            _id : bundle._id,
            name : bundle.name,
            description : bundle.description,
        });

        setIsDeleteMyBundleModalOpen(true);

    }

    const HandleBundleDelete = async () => {
        if(isOnProcess) return;

        setIsOnProcess(true);

        const isSuccess = await removeEmpowerMeBundlePersonalHook({
            variables : {
                _id : selectedMyBundle._id,
            }
        }).then((res) => res.errors ? false : true).catch(()=>false);

        if(!isSuccess) {
            setIsOnProcess(false);
            return;
        }

        Reloader("showPersonal=true");
    }

    return (
        <>
            <div className="w-100">
                <Breadcrumb listTag="div">
                    {
                        breadcrumbs.map((item, index) => (
                            <BreadcrumbItem 
                                role="button" 
                                key={index} 
                                active={index === breadcrumbs.length - 1}
                                onClick={() => HandleBreadcrumbsClick(index)}
                            >{item}</BreadcrumbItem>
                        ))
                    }
                </Breadcrumb>
            </div>
            <Row>
                <Col md={8}>
                    {
                        activeBreadcrumbs === 1 &&
                        <span>Step 1: Select the nudge type at “Single/Bundle”, then pick a category.</span>
                    }
                    {
                        activeBreadcrumbs === 2 && (selectedSubBundle || isPersonalBundleSelected)  &&
                        <div>
                            <span>Step 3: Pick a bundle to shedule.</span>
                        </div>
                    }
                    {
                        activeBreadcrumbs === 2 && selectedSubCategory  &&
                        <div>
                            <span>Step 3: Pick a nudge to shedule.</span>
                        </div>
                    }
                </Col>
                <Col md={4} className="d-flex justify-content-end">
                    <div className={styles.toggleSwitch}>
                        <button
                            className={`${styles.option} ${selectionType === SelectionTypes.SINGLE ? styles.active : ''}`}
                            onClick={() => HandleChangeSelectionType(SelectionTypes.SINGLE)}
                        >
                            Single
                        </button>
                        <button
                            className={`${styles.option} ${selectionType === SelectionTypes.BUNDLE ? styles.active : ''}`}
                            onClick={() => HandleChangeSelectionType(SelectionTypes.BUNDLE)}
                        >
                            Bundle
                        </button>
                    </div>
                </Col>
            </Row>
            

            {
                selectionType === SelectionTypes.SINGLE ? 
                <SingleSelector />
                :
                <BundleSelector />
            }

            <Modal
                id="em-scheduler-single-add-modal"
                className="modal-lg"
                backdrop={true}
                isOpen={openSingleSchedulerModal}>
                <ModalHeader toggle={ToggleSingleModal} className="pb-0">
                    <p className="text-lg">Schedule Single Nudge</p>
                </ModalHeader>
                <ModalBody>
                    <Formik
                        innerRef={formikRef}
                        initialValues={initialSingleNudgeValue}
                        // validationSchema={EditHealthHubValidator}
                        onSubmit={async (value : EmpowerScheduleForm) =>{
                            await HandleSingleSubmit(value);
                        }}
                    >
                        {({ setFieldValue, values }) => (
                            <Form>
                                <Row>
                                    <Col md={4} className="d-flex align-items-center">
                                        {
                                            selectedSingleEmTask &&
                                            <div >
                                                <img
                                                    src={
                                                        selectedSingleEmTask.image_id || selectedSingleEmTask.task_category.image ? 
                                                            getImageSmallUrl(selectedSingleEmTask.image_id || selectedSingleEmTask.task_category.image)
                                                        :
                                                            DefaultImage
                                                        }
                                                    alt={selectedSingleEmTask.name}
                                                    style={{ 
                                                        height: "200px",
                                                        objectFit: "cover",
                                                        width: "100%"
                                                    }}
                                                />
                                                <div className="small">
                                                    <div className="font-weight-bold">{selectedSingleEmTask.name}</div>
                                                    <div className="text-muted">{selectedSingleEmTask.description}</div>
                                                </div>
                                            </div>
                                        }
                                    </Col>
                                    <Col md={8}>
                                        <FormGroup>
                                            <Label>Date :</Label>
                                            <DateTime 
                                                className="w-100" 
                                                onChange={(date) => {
                                                    const reformated = moment(date).format("yyyy-MM-DD");
                                                    setFieldValue("date",reformated)   
                                                }} 
                                                dateFormat={DateFormat} 
                                                timeFormat={false}  
                                                initialValue={moment(initialSingleNudgeValue.date + " " + initialSingleNudgeValue.time,"YYYY-MM-DD HH:mm")}
                                                inputProps={{readOnly : true ,className:"form-control bg-white"}}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>Time :</Label>
                                            <DateTime 
                                                className="w-100" 
                                                onChange={(date) => {
                                                    const reformated = moment(date).format("HH:mm");
                                                    setFieldValue("time",reformated)   
                                                }}
                                                timeConstraints={{
                                                    hours: { min: 0, max: 23, step: 1 },
                                                    minutes: { min: 0, max: 59, step: 15 },
                                                    seconds: { min: 0, max: 59, step: 60 }, // keeps seconds locked at 00
                                                }}
                                                dateFormat={false} 
                                                timeFormat={true}  
                                                initialValue={moment(initialSingleNudgeValue.date + " " + initialSingleNudgeValue.time,"YYYY-MM-DD HH:mm")}
                                                inputProps={{readOnly : true ,className:"form-control bg-white"}}
                                            />
                                            { HandleValidationDate(values?.date, values?.time) }
                                        </FormGroup>

                                        <div className="mb-4">
                                            <Label>Repeat? :</Label>
                                            <div  className="d-flex">
                                                <Button onClick={() => HandleSingleChangeRepeat(true)} color={repeatSingle === true ? "primary" : "secondary"}>Yes</Button>
                                                <Button onClick={() => HandleSingleChangeRepeat(false)} color={repeatSingle === false ? "primary" : "secondary"}>No</Button>
                                            </div>
                                        </div>
                                        {
                                            repeatSingle &&
                                            <RecurrenceSelection
                                                recurrenceEnabled={repeatSingle}
                                                endConditionFieldName={RRuleEndConditionFieldName}
                                                endNever={RRuleEndNever}
                                                endOnDateFieldName={RRuleEndOnDateFieldName}
                                                endAfterCountFieldName={RRuleEndAfterCountFieldName}
                                            />
                                        }
                                    </Col>
                                </Row>
                            </Form>
                        )}
                    </Formik>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" disabled={isOnProcess} onClick={ToggleSingleModal} >Close </Button>
                    <Button color="primary" disabled={isOnProcess} onClick={() => formikRef.current?.submitForm() } >Schedule</Button>
                </ModalFooter>
            </Modal>
            
            <Modal
                id="em-scheduler-bundle-add-modal"
                className="modal-xl"
                backdrop={true}
                isOpen={openBundleSchedulerModal}>
                <ModalHeader toggle={ToggleBundleModal} className="pb-0">
                    <p className="text-lg">Schedule Bundle Nudge</p>
                </ModalHeader>
                <ModalBody>
                    <Formik
                        innerRef={formikRefBundle}
                        initialValues={initialBundleNudgeValue}
                        // validationSchema={EditHealthHubValidator}
                        onSubmit={async (value : EmpowerScheduleForm) =>{
                            await HandleBundleSubmit(value);
                        }}
                    >
                        {({ setFieldValue, values }) => (
                            <Form>
                                <div className="table-reponsive">
                                    <Table bordered>
                                        <thead>
                                            <tr>
                                                <th>Task</th>
                                                <th>Date</th>
                                                <th>Time</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                selectedEmpowerMeBundle &&
                                                selectedEmpowerMeBundle.tasks.map((item, index) => {

                                                    
                                                    const presetDate = moment(values.date + " " + values.bundleTimes[index],"YYYY-MM-DD HH:mm")
                                                    return (
                                                    <tr key={index}>
                                                        <td>
                                                            <div className="table-description-details-long" >
                                                                {item.empower_me_task_details.name}
                                                            </div>
                                                        </td>
                                                        {
                                                            index === 0 &&
                                                            <td rowSpan={3} className="align-middle" >
                                                                <DateTime 
                                                                    className="w-100" 
                                                                    onChange={(date) => {
                                                                        const reformated = moment(date).format("yyyy-MM-DD");
                                                                        setFieldValue("date",reformated)   
                                                                    }} 
                                                                    dateFormat={DateFormat} 
                                                                    timeFormat={false}  
                                                                    initialValue={presetDate}
                                                                    inputProps={{readOnly : true ,className:"form-control bg-white"}}
                                                                />
                                                            </td>
                                                        }
                                                        <td>
                                                            <DateTime 
                                                                className="w-100" 
                                                                onChange={(date) => {
                                                                    const reformated = moment(date).format("HH:mm");
                                                                    values.bundleTimes[index] = reformated

                                                                    setFieldValue("bundleTimes",values.bundleTimes)   
                                                                }}
                                                                timeConstraints={{
                                                                    hours: { min: 0, max: 23, step: 1 },
                                                                    minutes: { min: 0, max: 59, step: 15 },
                                                                    seconds: { min: 0, max: 59, step: 60 }, // keeps seconds locked at 00
                                                                }}
                                                                dateFormat={false} 
                                                                timeFormat={true}  
                                                                initialValue={presetDate}
                                                                inputProps={{readOnly : true ,className:"form-control bg-white"}}
                                                            />
                                                            { HandleValidationDate(values?.date, values?.bundleTimes[index], index) }
                                                        </td>
                                                    </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                </div>
                                <div className="mb-4 text-center">
                                    <Label>Repeat? :</Label>
                                    <div  className="d-flex justify-content-center">
                                        <Button onClick={() => HandleBundleChangeRepeat(true)} color={repeatBundle === true ? "primary" : "secondary"}>Yes</Button>
                                        <Button onClick={() => HandleBundleChangeRepeat(false)} color={repeatBundle === false ? "primary" : "secondary"}>No</Button>
                                    </div>
                                </div>
                                {
                                    repeatBundle &&
                                    <Row>
                                        <Col className="offset-md-3" md={6}>
                                            <RecurrenceSelection
                                                recurrenceEnabled={repeatBundle}
                                                endConditionFieldName={RRuleEndConditionFieldName}
                                                endNever={RRuleEndNever}
                                                endOnDateFieldName={RRuleEndOnDateFieldName}
                                                endAfterCountFieldName={RRuleEndAfterCountFieldName}
                                            />
                                        </Col>
                                    </Row>
                                }
                            </Form>
                        )}
                    </Formik>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" disabled={isOnProcess} onClick={ToggleBundleModal} >Close </Button>
                    <Button color="primary" disabled={isOnProcess} onClick={() => formikRefBundle.current?.submitForm() } >Schedule</Button>
                </ModalFooter>
            </Modal>

            <Modal
                id="em-scheduler-bundle-add-modal"
                className="modal-xl"
                backdrop={true}
                isOpen={openBundleCreatorModal}>
                <ModalHeader toggle={ToggleBundleCreatorModal} className="pb-0">
                    <p className="text-lg">{myBundleModalParams.label}</p>
                </ModalHeader>
                <ModalBody>
                    {
                        myBundleStep === 1 && selectedMyBundle &&
                        <>
                            <div>
                                <span>Step 1: Enter Name and Description.</span>
                            </div>

                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label>Name: *</Label>
                                        <Input
                                            placeholder="Name of the bundle"
                                            type="text"
                                            value={selectedMyBundle.name}
                                            onChange={(e) => setSelectedMyBundle((prev) => ({...prev, name : e.target.value}))}
                                        />
                                        {
                                            !selectedMyBundle.name &&
                                            <FormError>Required</FormError>
                                        }
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label>Description: *</Label>
                                        <Input
                                            placeholder="Ex. This is my custom bundle"
                                            type="textarea"
                                            value={selectedMyBundle.description}
                                            onChange={(e) => setSelectedMyBundle((prev) => ({...prev, description : e.target.value}))}
                                        />
                                        {
                                            !selectedMyBundle.description &&
                                            <FormError>Required</FormError>
                                        }
                                    </FormGroup>
                                </Col>
                                <Col md={12}>
                                </Col>
                            </Row>
                        </>
                        
                    }
                    {
                        myBundleStep === 2 &&
                        <div>
                            <div>
                                {
                                    selectedMyBundleSelectedEmpowerTasks.length !== 0 &&
                                    <div>
                                        <span>Selected Nudges : </span>
                                        <Row>
                                            {
                                            selectedMyBundleSelectedEmpowerTasks.map((item, index) => (
                                                <Col md={4} key={index}>
                                                    <Alert color="light" className="position-relative">
                                                        <div>
                                                            <div className="font-weight-bold small">{item.task_category.description}</div>
                                                            <small >{item.name}</small>
                                                        </div>
                                                        <Button
                                                            color="danger"
                                                            size="sm"
                                                            className="position-absolute top-0 right-0"
                                                            style={{transform: "translate(30%, -30%)"}}
                                                            onClick={() => { 
                                                                const selected = [...selectedMyBundleSelectedEmpowerTasks];
                                                                const getIndex = selected.findIndex( u => u._id === item._id)
                                                                if(getIndex !== -1) {
                                                                    selected.splice(getIndex, 1);
                                                                }

                                                                setSelectedMyBundleSelectedEmpowerTasks(selected);
                                                            }}
                                                        >
                                                            <i className="fas fa-times"></i>
                                                        </Button>
                                                    </Alert>
                                                </Col>
                                            ))
                                        }
                                        </Row>
                                    </div>
                                }
                            </div>
                            
                            {
                                breadcrumbsMyBundle.length !== 0 &&
                                <div className="w-100">
                                    <Breadcrumb listTag="div">
                                        {
                                            breadcrumbsMyBundle.map((item, index) => (
                                                <BreadcrumbItem 
                                                    role="button" 
                                                    key={index} 
                                                    active={index === breadcrumbsMyBundle.length - 1}
                                                    onClick={() => HandleMyBundleBreadcrumbsClick(index)}
                                                >{item}</BreadcrumbItem>
                                            ))
                                        }
                                    </Breadcrumb>
                                </div>
                            }
                            <div>
                                {
                                    activeMyBundleBreadcrumbs < 3  &&
                                    <>
                                        <div>
                                            <span>Step 2: Pick a category.</span>
                                        </div>
                                        <div className="mt-3">
                                            <CarouselRenderer
                                                data={SeparatePortions(categories,3)}
                                                renderer={MainCategoryRendererFormatterMyBundle}
                                                activeIndex={activeMyBundleIndex}
                                                setActiveIndex={setActiveMyBundleIndex}
                                                colSize={4}
                                            />
                                        </div>
                                    </>
                                }
                                

                                {
                                    activeMyBundleBreadcrumbs < 3 && selectedMyBundleMainCategory &&
                                    <>
                                        <div className="section-line-em" />
                                        <div>
                                            <span>Step 3: Pick a topic and see the list of nudges.</span>
                                        </div>
                                        <Row className="mt-2">
                                            {
                                                subCategories.filter(u => u.parent_id === selectedMyBundleMainCategory._id).map((item, index) => (
                                                    <SubCategoryRenderer 
                                                        key={index}
                                                        id={item._id}
                                                        description={item.description}
                                                        category={item}
                                                        onClick={MyBundleSubCategorySelector}
                                                    />
                                                ))
                                            }

                                        </Row>
                                    </>
                                }

                                {
                                    activeMyBundleBreadcrumbs === 3 &&
                                    <>
                                        <div>
                                            <span>Step 4: Pick a 3 Nudges. </span> <span className="text-primary">(Note : Use the breadcrumbs above to browse other categories and select nudges.)</span>
                                        </div>

                                        <Row>
                                        {
                                            empowerMeTasksSingles.filter(u => u.task_category._id === selectedMyBundleSubCategory?._id).map((item, index) => (
                                                <Col md={6} key={index}>
                                                    <EmpowerMeTaskItemsRenderer
                                                        item={item}
                                                        onClick={HandleSelectMyBundleEmTask}
                                                    />
                                                </Col>
                                            ))
                                        }
                                    </Row>
                                    </>
                                }
                            </div>
                        </div>
                    }
                    {
                        myBundleStep === 3 &&
                        <div className="text-center">
                            <h2>Just About Done!</h2>
                            <div>
                                Everything’s nearly done—just a heads-up: you can schedule this bundle once it's created!
                            </div>
                        </div>
                    }
                    
                </ModalBody>
                <ModalFooter>
                    
                    {
                        myBundleStep === 1 &&
                        <>
                            <Button color="secondary" disabled={isOnProcess} onClick={ToggleBundleCreatorModal} >Close </Button>
                            <Button color="primary" disabled={isOnProcess || (!selectedMyBundle?.name && !selectedMyBundle?.description)} onClick={() => setMyBundleStep(2) } >Next</Button>
                        </>
                    }
                    {
                        myBundleStep === 2 &&
                        <>
                            <Button color="secondary" disabled={isOnProcess} onClick={() => setMyBundleStep(1) } >Back </Button>
                            {
                                myBundleModalParams.action === "add" ?
                                    <Button color="primary" disabled={isOnProcess || selectedMyBundleSelectedEmpowerTasks.length !== 3} onClick={() => setMyBundleStep(3) } >Next</Button>
                                :
                                    <Button color="primary" disabled={isOnProcess || selectedMyBundleSelectedEmpowerTasks.length !== 3} onClick={HandleCreateMyBundleSubmit} >{myBundleModalParams.buttonName}</Button>
                            }
                        </>
                    }
                    {
                        myBundleStep === 3 &&
                        <>
                            <Button color="secondary" disabled={isOnProcess} onClick={() => setMyBundleStep(1) } >Back </Button>
                            <Button color="primary" disabled={isOnProcess || selectedMyBundleSelectedEmpowerTasks.length !== 3} onClick={HandleCreateMyBundleSubmit} >{myBundleModalParams.buttonName}</Button>
                        </>
                    }
                </ModalFooter>
            </Modal>

            <PromptDialogs
                isOpen={isDeleteMyBundleModalOpen}
                onCancel={() => { setIsDeleteMyBundleModalOpen(false); }}
                onConfirm={HandleBundleDelete}
                title="Delete Bundle"
                promptMessage="Are you sure you want to delete this Bundle?"
                confirmBtnTxt="Delete"
                isOnProcess={isOnProcess}
            />
        </>
    )
}